// TradeToolbar.tsx
import * as React from "react";
import { Box, Button } from "@chakra-ui/react";
import { FiRefreshCw } from "react-icons/fi";
import { IoFilter } from "react-icons/io5";
// import { PiExport } from "react-icons/pi";
import { FaPlus } from "react-icons/fa";
type Props = {
  userPermissions: any;
  onToggleFilters?: () => void;
  onRefresh?: () => void | Promise<void>;
  onExport?: () => void;
  onNewRecevier?: () => void;
  isLoading?: boolean;
};

const Toolbar: React.FC<Props> = ({
  userPermissions,
  onToggleFilters = () => {},
  onRefresh = () => {},
  onExport = () => {},
  onNewRecevier = () => {},
  isLoading = false,
}) => {
  return (
    <div className="mb-3 flex items-center justify-between">
      <h3 className="text-xl font-semibold text-navy-700 dark:text-white">
        Receivers
      </h3>

      <Box className="flex items-center justify-between gap-3">
        {userPermissions?.createReceiver && (
          <Button
            onClick={onNewRecevier}
            className="btn-secondary-green h-9 rounded-md border px-3 text-sm font-semibold tracking-tight shadow-sm"
            leftIcon={<FaPlus size={14} />}
          >
            Create New Receiver
          </Button>
        )}
        <Button
          variant="outline"
          onClick={onToggleFilters}
          className="h-9 rounded-md border border-gray-300 bg-white px-3 text-sm font-medium text-gray-700 hover:bg-gray-50"
          leftIcon={<IoFilter size={16} />}
        >
          Filters
        </Button>
        <Button
          variant="outline"
          onClick={onRefresh}
          isDisabled={isLoading}
          className="h-9 rounded-md border border-gray-300 bg-white px-3 text-sm font-medium text-gray-700 hover:bg-gray-50"
          leftIcon={<FiRefreshCw size={16} />}
        >
          Refresh
        </Button>
      </Box>
    </div>
  );
};

export default Toolbar;
